export enum BusinessIncapacityCause {
  ILLNESS = 'ILLNESS',
  ACCIDENT = 'ACCIDENT',
  MATERNITY = 'MATERNITY',
  OTHER = 'OTHER',
}

export const getBusinessIncapacityCauseLabel = (object: BusinessIncapacityCause) => {
  switch (object) {
    case BusinessIncapacityCause.ILLNESS:
      return $localize`Maladie`;
    case BusinessIncapacityCause.ACCIDENT:
      return $localize`Accident`;
    case BusinessIncapacityCause.MATERNITY:
      return $localize`Maternité`;
    case BusinessIncapacityCause.OTHER:
      return $localize`Autre`;
    default:
      return '';
  }
};
